import React from "react";
import ReactDOM from "react-dom";
import { ASSET_PATH } from "../utilities";
import closeIcon from "./close-X-gray.svg";
import closeIconHover from "./close-X-orange.svg";

const Modal = (props) => {
    const close = () => {
        props.setModalOpen(false);
    };

    if (props.modalOpen) {
        return ReactDOM.createPortal(
            <div className="modal-wrapper-bulk-add">
                <div onClick={close} className="modal-backdrop-bulk-add">
                    <div
                        onClick={(e) => {
                            // stop onClick event bubbling that closes the modal
                            e.stopPropagation();
                        }}
                        className="modal-box-bulk-add"
                    >
                        <div className="modal-title-headline">
                            {props.modalTitle}
                            <button onClick={close} className="btn-close">
                                <img
                                    src={ASSET_PATH + closeIcon}
                                    className="modal-close-icon default"
                                    alt="Close"
                                />
                                <img
                                    src={ASSET_PATH + closeIconHover}
                                    className="modal-close-icon hover"
                                    alt="Close"
                                />
                            </button>
                        </div>
                        {props.children}
                    </div>
                </div>
            </div>,
            document.getElementById("modal-root")
        );
    }

    return null;
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal.js